<template>
	<el-autocomplete ref="autocomplete" class="filter-item query-item-input acc" popper-class="optionClass"
		:popper-append-to-body="false" :value="fuzzyValue || selectLabel" :clearable="clearable"
		:placeholder="placeholder" :fetch-suggestions="querySearch" :debounce="200" :hide-loading="true"
		:value-key="option.label" :disabled="disabled" @input="fuzzyValueInput" @change="fuzzyValueChange"
		@select="fuzzyValueSelect" @clear="clear">
		<template slot-scope="{item}">
			<slot :item="item">
				<div v-if="option.optionLeftLabel"
					style="display: flex;justify-content: space-between;align-items: center;">
					<span>{{ item[option.optionLeftLabel] }}</span>
					<span v-if="option.optionRightLabel" style="margin-left: 40px;font-size: 12px;color: #909399;">{{
						item[option.optionRightLabel] }}</span>
				</div>
			</slot>
		</template>
	</el-autocomplete>
</template>

<script>
import request from '@/utils/request'
import setData from './setting.js'
import { dedupeByKey } from './setting.js';
export default {
	name: 'FuzzyInput',
	props: {
		// 双向绑定
		value: {
			required: true
		},
		placeholder: {
			type: String,
			default: '请输入'
		},
		// 是否可清除
		clearable: {
			type: Boolean,
			default: true
		},
		// 建议选项的标识
		sign: {
			type: String,
			required: true
		},
		// 建议选项请求参数
		params: {
			type: Object,
			default: () => {
				return {}
			}
		},
		// 对列表数据的处理方法
		handleMethod: {
			type: Function,
			default: (str, list) => {
				return list
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		// 去重键
		dedupeKey: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			api: setData[this.sign].api,
			option: setData[this.sign].option,
			fuzzyValue: this.value,
			selectLabel: '',
			pageObj: {
				page: 1,
				size: 10
			},
		}
	},
	watch: {
		value(newVal) {
			this.fuzzyValue = newVal.replace(/\s+/g, '')
		},
		fuzzyValue(newVal) {
			this.$emit('input', newVal)
		}
	},
	mounted() {
		// 设置下拉框最小宽度
		this.$nextTick(() => {
			let el = this.$refs.autocomplete.$el.getElementsByClassName('el-autocomplete-suggestion')[0]
			el.style.minWidth = this.$refs.autocomplete.$el.clientWidth + 'px'
		})
	},
	methods: {
		// 根据输入的值返回建议选项
		async querySearch(queryString, cb) {
			// console.log('queryString', queryString)
			let res = await this.getList(queryString)
			let results
			if (res.records) {
				results = res.records || []
			} else {
				results = res || []
			}
			results = this.handleMethod(queryString, results)

			if (this.dedupeKey) {
				results = dedupeByKey(results, this.dedupeKey)
			}
			// 调用 callback 返回建议列表的数据
			cb(results);
		},
		// 获取列表
		getList(queryString) {
			let params = { page: this.pageObj.page, size: this.pageObj.size, ...this.params, [this.option.label]: queryString }
			return request({ url: this.api, method: 'get', params })
		},
		clear() {
			this.$refs.autocomplete.activated = true
			this.selectLabel = ''
			this.$refs.autocomplete.getData(this.fuzzyValue)
			this.$emit('clear')
		},
		// fuzzyValue改变
		fuzzyValueChange(val) {
			this.$emit("change", val)
		},
		fuzzyValueSelect(item) {
			let val = item[this.option.label]
			if (this.type == 'input_select') {
				this.selectLabel = val
				this.$emit("change", null)
				this.$emit("select", val, item)
			}
			else {
				this.$emit("change", val, item)
			}
		},
		fuzzyValueInput(val) {
			this.fuzzyValue = val
		}
	}
}

</script>

<style scoped lang="scss">
/deep/ .el-popper[x-placement^=bottom] {
	width: unset !important;
}
</style>
